<div class="tab-inner-content">
  <h2>Balance Sheet</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>

  <ng-container *ngFor="let section of sections">
    <table *ngIf="balanceSheetReport?.[section.key]?.length">
      <thead>
        <tr>
          <p class="balance-sheet-label-title">{{ section.label }}</p>
        </tr>
        <tr>
          <th>Account Name</th>
          <th>Total Debit (In AED)</th>
          <th>Total Credit (In AED)</th>
          <th>Net Amount (In AED)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let node of balanceSheetReport?.[section.key]">
          <td>{{ node.accountName }}</td>
          <td>{{ node.totalDebit | number : "1.2-2" }}</td>
          <td>{{ node.totalCredit | number : "1.2-2" }}</td>
          <td>{{ node.netAmount | number : "1.2-2" }}</td>
        </tr>
        <tr class="title">
          <td>Total {{ section.label }}</td>
          <td></td>
          <td></td>
          <td>
            {{ balanceSheetReport?.[section.totalKey] | number : "1.2-2" }}
          </td>
        </tr>
        <tr *ngIf="section.key === 'equity'" class="title secondary-total">
          <td>Total Equity and Liability</td>
          <td></td>
          <td></td>
          <td>
            {{ totalEquityLiability | number : "1.2-2" }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </ng-container>
</div>
